import React from 'react';

import WsIconProps from './IconProps';

const Applications: React.FC<WsIconProps> = ({
  color = '#F2FBFD',
  width = 24,
  height = 24,
  color2 = '#90E0EF',
  color3 = '#F2FBFD',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
      fill={color}
    />
    <path
      d="M6 6.5C6 5.39543 6.89543 4.5 8 4.5H14.25L15.75 6L18 8.25V12V17.5C18 18.6046 17.1046 19.5 16 19.5H8C6.89543 19.5 6 18.6046 6 17.5V6.5Z"
      fill={color2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2652 13.0147L10.875 17.4049L8.73486 15.2647L9.26519 14.7344L10.875 16.3442L14.7349 12.4844L15.2652 13.0147Z"
      fill={color3}
    />
    <rect x="8.25" y="9" width="6.75" height="0.75" fill={color3} />
    <rect x="8.25" y="7.5" width="5.25" height="0.75" fill={color3} />
    <rect width="3.75" height="0.75" transform="matrix(1 0 0 -1 8.25 11.25)" fill={color3} />
  </svg>
);

export default Applications;
